export default __webpack_public_path__ + "static/media/back.a1d7b890.svg";